export default {
    common: {
        inMonth: 'in {month}',
        than: 'than {month}',
        thanSamePeriod: 'than at this point {month}',
        noCategory: 'Uncategorised',
        monthLoadFailed: 'Couldn’t load the month.',
        markedPaid: '“{name}” marked as paid.',
        statusFailed: 'Couldn’t change the status.',
        expenseAdded: 'Expense added.',
        expenseSaved: 'Expense saved.',
        expenseDeleted: 'Expense deleted.',
        addExpense: 'Add expense',
        noExpenses: 'No expenses this month.',
        vsAverageNote: 'Compared with the average of the previous 3 months.',
        markPaidLabel: '{name}: mark as paid',
        markPaid: 'Mark as paid',
        loanInstalment: 'loan instalment',
    },
    overview: {
        title: 'Overview',
        overdueDays: 'overdue ({n} day) | overdue ({n} days)',
        today: 'today',
        tomorrow: 'tomorrow',
        inDays: 'in {n} days',
        nextInstalment: 'Next instalment: {name} · {amount} · {when}',
        balanceTitle: 'BALANCE · {month}',
        income: 'Income',
        expenses: 'Expenses',
        paymentsAndInstalments: 'Payments and instalments',
        stillToPay: 'of which {amount} still to pay',
        left: 'Left over',
        short: 'Short by',
        savingRate: 'you’re saving {pct}% of your income',
        overspent: 'expenses exceed income',
        noIncome: 'no income this month',
        budgetPct: '{name}: {pct}% of budget',
        expensesOf: 'Expenses · {month}',
        dailyAverage: 'Daily average',
        forecast: 'End-of-month forecast',
        expenseCount: 'Number of expenses',
        trendHint: 'Last {n} months — click a bar to go to that month',
        paymentsTitle: 'PAYMENTS · {month}',
        leftToPay: 'Left to pay',
        allPaid: 'All paid',
        paymentsProgress: '{paid} of {all} · {n} item to pay | {paid} of {all} · {n} items to pay',
        noListCreate: 'No list for this month — create one in Payments.',
        loansTitle: 'LOANS',
        monthlyInstalments: 'Monthly instalments',
        toRepay: '{amount} to repay',
        nearestEnd: 'ending soonest: {name} ({n} instalment) | ending soonest: {name} ({n} instalments)',
        noLoans: 'No loans.',
        commitmentsTitle: 'FIXED COMMITMENTS / MONTH',
        fixedPart: 'recurring payments {amount}',
        fixedAvgNote: '(average, including quarterly and yearly)',
        loansPart: 'instalments {amount}',
        plusAverage: 'plus an average of {amount} in expenses / month',
        whereMoneyGoes: 'WHERE THE MONEY GOES',
        toPayTitle: 'TO PAY',
        overdueCount: '{n} overdue',
        all: 'All',
        allPaidDot: 'All paid.',
        noList: 'No payment list for this month.',
        andMore: 'and {n} more…',
        recentTitle: 'RECENT EXPENSES',
    },
    due: {
        overdue: '{n} day overdue | {n} days overdue',
        today: 'due today',
        tomorrow: 'due tomorrow',
        inDays: 'in {n} days · {date}',
        by: 'by {date}',
    },
    intervals: {
        monthly: 'monthly',
        quarterly: 'quarterly',
        yearly: 'yearly',
    },
    form: {
        name: 'Name',
        amount: 'Amount',
        date: 'Date',
        category: 'Category',
    },
    expenses: {
        title: 'Expenses',
        today: 'Today',
        yesterday: 'Yesterday',
        receiptSaved: 'Expenses from the receipt saved.',
        fromReceiptHint: 'Load expenses from a receipt photo',
        fromReceipt: 'From receipt',
        spent: 'Spent',
        perDay: 'Per day',
        forecast: 'Forecast',
        count: 'Expenses',
        biggest: 'Biggest: {name} · {amount}',
        categoryFilter: 'Category filter',
        search: 'Search expenses',
        clearFilter: 'Clear filter',
        filteredSummary: '{n} expense · {part} of {total} | {n} expenses · {part} of {total}',
        noMatch: 'Nothing matches the filter',
        empty: 'No expenses this month',
        noMatchHint: 'Change the search or clear the filter.',
        emptyHint: 'Add an expense manually or load a receipt.',
        categories: 'CATEGORIES',
        manage: 'Manage',
        categoriesHint: 'Click a category to narrow the list. Compared with the average of the previous 3 months.',
    },
    income: {
        title: 'Income',
        add: 'Add income',
        unsupported: 'The API doesn’t support income yet.',
        received: 'Received',
        compareSame: 'the same as {month}',
        compareMore: '{pct}% more than {month}',
        compareLess: '{pct}% less than {month}',
        recurring: 'Recurring',
        oneOff: 'One-off',
        expected: 'Not received yet (came in last month)',
        empty: 'No income this month',
        emptyHint: 'Add your salary and other income — Overview will work out the balance from them.',
        sources: 'SOURCES',
        categories: 'Categories',
        none: 'No income.',
        count: '{n} income entry this month. | {n} income entries this month.',
        form: {
            source: 'From',
            sourcePlaceholder: 'e.g. Salary',
            noCategories: 'You can add income categories in the Categories tab.',
            recurring: 'Recurring',
            recurringHint: 'Every month (e.g. salary) — counts towards the forecast',
        },
        dialog: {
            edit: 'Edit income',
            new: 'New income',
        },
        flash: {
            added: 'Income added.',
            saved: 'Income saved.',
            saveFailed: 'Couldn’t save the income.',
            deleted: 'Income deleted.',
            deleteFailed: 'Couldn’t delete the income.',
        },
    },
    categories: {
        title: 'Categories',
        count: '{n} category | {n} categories',
        add: 'Add category',
        edit: 'Edit category',
        tabs: {
            expenses: 'Expenses',
            payments: 'Payments',
            income: 'Income',
        },
        thisMonth: '{amount} this month',
        average: 'average {amount} / month',
        noHistory: 'no expenses in the previous 3 months',
        incomeCount: '{n} income entry | {n} income entries',
        noIncome: 'no income this month',
        fixedCount: '{n} recurring payment | {n} recurring payments',
        loanCount: '{n} loan | {n} loans',
        perMonth: '{amount} / month',
        nothingAssigned: 'nothing assigned',
        placeholder: {
            expenses: 'e.g. Food',
            payments: 'e.g. Housing',
            income: 'e.g. Salary',
        },
        budget: 'Monthly budget',
        budgetHint: 'Limit per month — empty = no budget.',
        saveFailed: 'Couldn’t save the category.',
        deleteMessage: {
            expenses: 'A category assigned to expenses can’t be deleted — change the category in those expenses first.',
            payments: 'Recurring payments, loans and list items will stay, just without a category.',
            income: 'Income entries will stay, just without a category.',
        },
        deleted: 'Category deleted.',
        inUse: 'The category has expenses assigned — change their category first.',
        deleteFailed: 'Couldn’t delete the category.',
        intro: {
            expenses: 'Every expense needs a category. Amounts: the current month and the average of the previous 3; set a budget by clicking a category.',
            payments: 'They group recurring payments, loans and items on the monthly list. Amount: how much goes on recurring payments and instalments in the category each month.',
            income: 'Sources of income, e.g. salary, bonuses, refunds. Amount: how much came in this month.',
        },
        unsupported: {
            expenses: 'The API doesn’t support expense categories yet.',
            payments: 'The API doesn’t support payment categories yet.',
            income: 'The API doesn’t support income categories yet.',
        },
        empty: {
            expenses: 'No expense categories',
            payments: 'No payment categories',
            income: 'No income categories',
        },
        newTitle: {
            expenses: 'New expense category',
            payments: 'New payment category',
            income: 'New income category',
        },
        rename: 'Rename: {name}',
        budgetUsage: '{pct}% of {limit}',
        delete: 'Delete category',
        deleteNamed: 'Delete category {name}',
        confirmTitle: 'Delete category?',
    },
    loans: {
        title: 'Loans',
        add: 'Add loan',
        instalments: '{n} instalment | {n} instalments',
        years: '{n} year | {n} years',
        yearsMonths: '{years} and {m} mo.',
        due: {
            lateShort: '{n} day overdue | {n} days overdue',
            lateText: 'Instalment overdue — {date} ({n} day ago) | Instalment overdue — {date} ({n} days ago)',
            todayShort: 'instalment today',
            todayText: 'Instalment today — {date}',
            tomorrowShort: 'instalment tomorrow',
            tomorrowText: 'Instalment tomorrow — {date}',
            inDaysShort: 'instalment in {n} days',
            inDaysText: 'Instalment in {n} days — {date}',
            nextText: 'Next instalment {date} · in {n} days',
        },
        sort: {
            label: 'Sorting',
            next: 'Sort: next instalment',
            end: 'Sort: end date',
            name: 'Sort: name',
            instalment: 'Sort: instalment',
            left: 'Sort: remaining',
        },
        form: {
            categoryHint: 'Instalments on new monthly lists will get this category.',
            categoryHintEmpty: 'First add categories in “Payment categories”.',
            where: 'Where',
            wherePlaceholderLegacy: 'e.g. Bank X',
            wherePlaceholder: 'e.g. Mortgage / Credit card',
            totalAmount: 'Loan amount',
            instalment: 'Instalment',
            instalmentsLeft: 'Instalments left',
            end: 'End',
            kind: 'Type',
            kindInstalment: 'Instalment loan (has an end date)',
            kindRevolving: 'Credit card / overdraft (no end date)',
            capital: 'Remaining principal / debt',
            capitalHint: 'From your banking app. Each paid instalment reduces it by its principal part.',
            minimumPayment: 'Minimum payment',
            minimumPaymentHint: 'From the bank — the least you must repay of the debt each month (interest separately).',
            plannedPayment: 'Instalment / planned repayment',
            plannedPaymentHint: 'Loan: the current instalment (change it when the bank recalculates). Card: how much debt you repay each month — at least the minimum; interest comes on top.',
            interestRate: 'Bank interest rate',
            interestRateHint: 'The bank’s nominal annual rate (not APR). Optional for a loan — without it I’ll work it out from the instalment.',
            instalmentType: 'Instalments',
            equal: 'Equal',
            decreasing: 'Decreasing',
            paymentDay: 'Payment day',
            paymentDayHint: '29–31 in shorter months = the last day.',
            nextPayment: 'Next payment',
            nextPaymentHintEdit: 'Change it if the due date has moved.',
            nextPaymentHint: 'Empty = the next payment day from today.',
            lastInstalment: 'Last instalment',
            lastInstalmentHint: 'From the bank’s schedule.',
            calc: 'Calculation',
        },
        overpayModes: {
            shorten: 'shorter term',
            lower: 'lower instalment',
        },
        flash: {
            paidSplit: '“{name}” instalment paid — {capital} principal, {interest} interest.',
            paidAmount: '“{name}” instalment paid — {amount}.',
            noInstalmentsLeft: 'This loan has no instalments left to pay.',
            payFailed: 'Couldn’t mark the instalment.',
            reverted: 'Reverted the last “{name}” instalment.',
            revertFailed: 'Couldn’t revert the instalment.',
            overpaid: 'Overpayment of {amount} saved — principal {capital}.',
            overpayReverted: 'Reverted the {amount} overpayment.',
            overpayRevertFailed: 'Couldn’t revert the overpayment.',
        },
        capitalUnchecked: 'principal not checked with the bank',
        capitalChecked: 'principal checked {n} month ago | principal checked {n} months ago',
        capitalStale: '{age} — copy it from your banking app',
        dialog: {
            new: 'New loan',
            edit: 'Edit loan',
            editRevolving: 'Edit card / overdraft',
        },
        principal: 'Principal',
        toRepay: 'To repay',
        ofWhichInterest: 'Of which interest',
        nextDue: 'Next instalment: {name} · {date} · {amount}',
        groupMonthly: '{amount} / mo',
        groupCapital: 'principal {amount}',
        payableOn: 'Due on day {day} of the month',
        everyMonth: 'monthly',
        editNamed: 'Edit: {name}',
        paidOff: 'Paid off',
        monthsToRepay: '{n} mo. to repay',
        revolvingBadge: 'card / overdraft',
        payableDay: 'due on day {day}',
        lastOn: 'last {date}',
        revertTitle: 'Revert the last paid instalment — {name}',
        revertLabel: 'Revert last instalment: {name}',
        payTitle: 'Instalment paid: reduces the principal by its principal part and marks the instalment on the monthly list',
        paid: 'Paid',
        thisMonth: 'This month',
        repayPlusInterest: '{repay} repayment + {interest} interest',
        minimum: 'min. {amount}',
        debt: 'Debt',
        principalLeft: 'Remaining principal',
        fillIn: 'Fill in',
        interestLeft: 'Interest to the end',
        rateYearlyBank: '{rate}% a year (bank)',
        rateYearlyApprox: 'approx. {rate}% a year',
        neverPaidOff: 'Without a planned repayment the debt doesn’t go down — enter how much you repay each month.',
        hidePlan: 'Hide repayment plan',
        plan: 'Repayment plan',
        overpay: 'Overpay',
        empty: 'No loans',
        emptyHint: 'Loan instalments also go on the monthly payment list.',
        undo: 'Undo',
        calc: {
            belowMinimum: 'The planned repayment is below the minimum.',
            never: 'Without a repayment the debt doesn’t go down — each month you pay only interest, approx. {amount}.',
            dueNow: 'Due this month {due} = {repay} repayment + {interest} interest',
            payoff: 'You’ll pay it off in {months} · total interest {interest}',
            monthsShort: '{n} mo.',
            noNewPurchases: '(with no new card purchases)',
            invalid: 'This instalment won’t repay this principal in {n} instalment — check the amounts or the last instalment date. | This instalment won’t repay this principal in {n} instalments — check the amounts or the last instalment date.',
            summary: '{count} left · to repay {total} · of which interest {interest}',
            mismatch: 'The instalment, principal and dates give approx. {implied}%, but the bank states {rate}%. Check the last instalment date, the principal, or whether the instalment includes insurance.',
            rateBank: 'Interest rate {rate} a year (from the bank)',
            rateApprox: 'Interest rate approx. {rate} a year',
            nextSplit: 'next instalment: {capital} principal + {interest} interest',
            forecastNote: 'Forecast at the current instalment. When the bank changes the instalment or after an overpayment — update the instalment (or the last instalment date).',
            enterCapital: '— enter the principal and I’ll work out the interest and rate.',
            hint: 'Enter the instalment, payment day and last instalment — I’ll work out the number of instalments, interest and rate.',
        },
        history: {
            title: 'Paid instalments',
            loading: 'Loading…',
            split: 'principal {capital} · interest {interest}',
            empty: 'No instalment has been marked as paid yet.',
            overpayments: 'Overpayments',
            revertOverpayment: 'Revert the overpayment — principal, instalment and end date go back to how they were before it',
        },
    },
    payments: {
        title: 'Payments',
        addItem: 'Add item',
        addFixed: 'Add recurring payment',
        intervals: {
            monthly: 'Monthly',
            quarterly: 'Quarterly',
            yearly: 'Yearly',
        },
        yearlyDay: '{day} {month}',
        dayOf: 'day {day}',
        paid: 'paid',
        paidOn: 'paid {day} {month}',
        tabs: {
            month: 'This month',
            fixed: 'Recurring payments',
        },
        options: {
            title: 'Options',
            linkActive: 'Paid items go to expenses',
            refresh: 'Refresh from definitions',
            refreshHint: 'Pulls in new recurring payments and instalments; statuses stay.',
            addAsExpense: 'Add paid items to expenses',
            expenseCategory: 'Expense category',
            expenseCategoryLabel: 'Expense category for paid payments',
            pickCategory: 'Choose an expense category.',
            deviceSetting: 'Setting for this device.',
        },
        categoriesLink: 'Payment categories',
        toPay: 'To pay',
        items: '{n} item | {n} items',
        paidTitle: 'Paid',
        skippedCount: '{n} skipped',
        monthTotal: 'Month total',
        progressLabel: 'Paid share of the month',
        allPaidMonth: 'Everything for this month is paid.',
        nothingPaid: 'Nothing paid yet this month.',
        listEmpty: 'The list is empty — add an item or refresh from definitions in “Options”.',
        noList: 'No list for {month}',
        noListHint: 'Create it — items will be made from recurring payments and loan instalments.',
        createList: 'Create list',
        fixedIntro: 'They go on every new monthly list together with loan instalments.',
        monthlyAverage: 'Monthly average',
        monthlyTotal: 'Monthly total',
        fixedEmpty: 'No recurring payments — add rent, electricity, subscriptions.',
        form: {
            dueDate: 'Due date',
            optional: 'Optional',
            itemPlaceholder: 'e.g. Electricity',
            fixedPlaceholder: 'e.g. Subscription',
            fixedHint: 'It will go on every generated monthly list.',
            interval: 'How often',
            startMonth: 'First month',
            startMonthHint: 'For quarterly and yearly ones — the next ones count from it.',
        },
        confirm: {
            title: 'Remove item from the list?',
            message: 'It will only disappear from this month’s list — the recurring payment definition stays.',
        },
        dialog: {
            newItem: 'New list item',
            editItem: 'Edit item',
            editFixed: 'Edit recurring payment',
            newFixed: 'New recurring payment',
        },
        flash: {
            paidAsExpense: '“{name}” paid and added to expenses.',
            itemSaveFailed: 'Couldn’t save the item.',
            itemDeleteFailed: 'Couldn’t delete the item.',
            createFailed: 'Couldn’t create the list for this month.',
            refreshFailed: 'Couldn’t refresh the list.',
            itemAddFailed: 'Couldn’t add the item.',
            fixedSaveFailed: 'Couldn’t save the recurring payment.',
            deleteFailed: 'Couldn’t delete.',
        },
    },
    bars: {
        ofLimit: 'of {amount}',
        over: 'Budget exceeded by {amount}',
        willExceed: 'At this pace: ~{amount} by the end of the month',
        leftWarn: '{amount} of the budget left',
        left: '{amount} of the budget left',
        avgHint: 'Average {amount} / month in previous months (in the current month, pro rata to the days)',
        vsAvg: '{pct}% vs avg',
        asUsual: 'as usual',
    },
    delta: {
        noData: 'no data to compare',
        same: 'no change',
        more: '{pct}% more {suffix}',
        less: '{pct}% less {suffix}',
    },
    expenseForm: {
        name: 'What for',
        namePlaceholder: 'e.g. groceries at Tesco',
        noCategories: 'First add a category in the Categories tab.',
        saveFailed: 'Couldn’t save the expense.',
        deleteFailed: 'Couldn’t delete the expense.',
        edit: 'Edit expense',
        new: 'New expense',
    },
    chart: {
        thousands: '{n}k',
        average: 'average {amount}',
        caption: 'Expenses in consecutive months',
    },
    switcher: {
        prev: 'Previous month',
        next: 'Next month',
        today: 'Today',
    },
    row: {
        undoPaid: 'Undo — back to unpaid',
        restore: 'Restore to unpaid',
        skipped: 'skipped this month',
        noDueDate: 'no due date',
        inExpenses: 'in expenses',
        skipHint: 'Skip this month — not counted in totals',
        restoreNamed: 'Restore {name}',
        skipNamed: 'Skip {name}',
    },
    plan: {
        spanJoin: '{years} and {months}',
        monthlyRepayment: 'I repay of the debt monthly',
        plusInterest: '(+ interest)',
        compareLabel: 'Repayment amount comparison',
        minimum: 'minimum',
        current: 'plan',
        compareResult: '{months} · interest {interest}',
        neverRepays: 'won’t repay the debt',
        never: 'Without a repayment the debt doesn’t go down — each month you pay only interest, approx. {amount}. Enter a repayment amount.',
        missingData: 'Missing data for the plan: principal, instalment or interest rate.',
        end: 'Repayment ends',
        left: 'Left',
        totalInterest: 'Total interest',
        totalPaid: 'You’ll pay in total',
        chartTitle: 'Debt over time',
        chartLabel: 'Debt goes down from {amount} to zero in {n} months',
        now: 'Now',
        balance: 'balance {amount}',
        payment: 'payment {paid}: {capital} principal · {interest} interest',
        scheduleMonthly: 'Monthly schedule',
        scheduleYearly: 'Year-by-year schedule',
        showYears: 'Show year by year',
        showMonths: 'Show months',
        month: 'Month',
        year: 'Year',
        payments: 'Payments',
        interest: 'Interest',
        endBalance: 'Closing balance',
        forecast: 'Forecast at the current interest rate ({rate}% a year).',
        forecastRevolving: 'Forecast at the current interest rate ({rate}% a year) and with no new card purchases.',
    },
    overpay: {
        amountRequired: 'Enter the overpayment amount.',
        saveFailed: 'Couldn’t save the overpayment.',
        title: 'Overpayment — {name}',
        close: 'Close',
        amount: 'Overpayment amount',
        moreThanDebt: 'More than the debt ({amount}).',
        moreThanCapital: 'More than the remaining principal ({amount}).',
        question: 'What does the bank do with the overpayment?',
        variant: 'Overpayment option',
        shorten: 'Shorter term',
        shortenHint: 'same instalment, earlier end',
        lower: 'Lower instalment',
        lowerHint: 'same end, smaller instalment',
        endLabel: 'end:',
        monthsEarlier: '({n} mo. earlier)',
        newInstalment: 'new instalment:',
        youSave: 'you save {amount} in interest',
        useCalc: 'Use the calculation',
        bankOther: 'Did the bank give different figures?',
        bankInstalment: 'New instalment from the bank',
        bankInstalmentPlaceholder: 'e.g. 650.00',
        bankEnd: 'New last instalment date from the bank',
        debtDrops: 'The debt will drop to {amount}.',
        payoffIn: 'With the current plan you’ll pay it off in {n} mo.',
        youSaveApprox: 'you save approx. {amount} in interest',
        capitalDrops: 'The principal will drop to {amount}.',
        previewNeeds: 'The preview needs the remaining principal and the loan’s interest rate.',
        note: 'Note — optional',
        notePlaceholder: 'e.g. from a bonus',
        cancel: 'Cancel',
        saving: 'Saving…',
        save: 'Save overpayment',
    },
    loansMonth: {
        status: {
            paid: 'paid',
            due: 'to pay',
            late: 'overdue',
        },
        title: 'Instalments this month · {month}',
        total: 'Total {amount}',
        totalLower: 'total {amount}',
        paid: 'paid {amount}',
        left: '{amount} left',
        allPaid: 'all paid',
        next: 'next: day {day} ({name})',
        chartLabel: 'Loan instalments by day of the month: {month}',
        today: 'today',
        noInstalments: 'no instalments',
    },
    timeline: {
        ranges: {
            year: 'Year',
            threeYears: '3 years',
            all: 'To the end',
        },
        noPlan: 'no repayment plan',
        title: 'Monthly instalments over time',
        now: 'Now: {amount} in {month}',
        stillToPay: '{amount} still to pay',
        nextChange: 'from {month}, {amount} less ({names})',
        rangeLabel: 'Timeline range',
        chartLabel: 'Monthly loan instalments from {from} to {to}',
        nowMarker: 'now',
        past: 'past',
        forecast: 'forecast',
        noList: 'no payment list for this month',
        unpaid: 'unpaid',
        legendPast: 'past (from payment lists)',
        legendCurrent: 'current month',
        loadingPast: 'loading previous months…',
        lanesTitle: 'When the loans end',
        perMonth: '{amount}/mo',
    },
    import: {
        newCategoryOption: '+ new category',
        tooManyFiles: 'At most {n} files at once.',
        unsupportedType: '{name}: we support JPG, PNG, WEBP and PDF.',
        fileTooLarge: '{name} is larger than 20 MB.',
        totalTooLarge: 'No more than 45 MB in total.',
        noneFound: 'No expenses were found in the photos.',
        invalidImages: 'No valid images were uploaded.',
        noResponse: 'The receipt analysis service didn’t respond. Try again.',
        notConfigured: 'Receipt analysis isn’t configured.',
        analyzeFailed: 'Couldn’t analyse the photos.',
        saveFailed: 'Couldn’t save the expenses.',
        title: 'Import from a photo',
        uploadHint: 'Receipt photos or a PDF — the analysis will extract the rest.',
        reviewHint: 'Check the suggestions before saving.',
        chooseFiles: 'Choose files',
        takePhoto: 'Take a photo',
        limits: 'up to {n} files, 45 MB in total',
        removeFile: 'Remove file',
        note: 'Hint for the analysis',
        notePlaceholder: 'e.g. weekly grocery shop',
        namePlaceholder: 'expense name',
        pickCategory: 'Choose a category',
        newCategoryName: 'New category name',
        newCategoryPlaceholder: 'e.g. Pharmacy',
        removeRow: 'Remove item',
        addRow: 'Add an item manually',
        back: 'Back to files',
        analyzing: 'Analysing…',
        analyze: 'Analyse',
        save: 'Save {n} expense | Save {n} expenses',
    },
};
